import type { TokenData } from "@/common/types/chat.types";
import config from "./config";
import theme from "./theme";
import App from "@/common/App";
import { createRoot } from "react-dom/client";

interface StoreContextData {
  storeId: string | null;
  customerNumber: string | null;
  appNames: string;
}

export default function main(
  container: HTMLElement,
  options?: { 
    getToken?: () => Promise<TokenData>; 
    startLogin?: () => Promise<void>;
  }
) {

  const getUserData = (): StoreContextData => {
    const siteState = (window as any)['siteState'];
    const storeId = siteState?.user?.chosenStore?.storeId;
    const customerNumber = siteState?.user?.chosenStore?.customerNumber;
    const appNames = (siteState?.spaTiles || [])
      .map((app: { name?: string }) => app.name)
      .join(',');
    
    return {
      storeId: storeId ? String(storeId) : null,
      customerNumber: customerNumber ? String(customerNumber) : null,
      appNames: appNames
    };
  }

  const refreshToken = async (): Promise<string> => {
    const siteState = (window as any)["siteState"];
    const refreshedToken = await siteState?.user?.token?.refresh();

    return refreshedToken;
  };

  const root = createRoot(container);
  root.render(
    <div style={theme as React.CSSProperties}>
      <App
        config={config}
        getToken={options?.getToken}
        startLogin={options?.startLogin}
        getOpcoContextData={getUserData}
        refreshToken={refreshToken}
      />
    </div>
  );
  
  return root;
}